import React, { useState } from 'react'
import DOMPurify from 'dompurify'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import {
  Promo,
  PromoContainer,
  PromoContent,
  HoverOverlayButton
} from './PromoDetails.styles'
import PromoGlobalStyles from './PromoGlobalStyles'
import { Button } from '@dsny/dsny-component-library'
import { PROMO_SANITIZE_OPTIONS } from '../../utils'
import useReleaseInformationResponsiveBreakpointsV2 from '../../hooks/useReleaseInformationResponsiveBreakpointsV2'

export default function PromoDetails({ promoInfo, setIsExpanded, isExpanded }) {
  const theme = useTheme()
  const { t } = useTranslation()
  const responsiveBreakpointsV2 = useReleaseInformationResponsiveBreakpointsV2()
  const sanitizedPromoinfoHtml = DOMPurify.sanitize(
    promoInfo,
    PROMO_SANITIZE_OPTIONS
  )

  return (
    <Promo $responsiveBreakpointsV2={responsiveBreakpointsV2}>
      <PromoContainer>
        <PromoGlobalStyles />
        <PromoContent id="promo-container">
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizedPromoinfoHtml
            }}
          />
        </PromoContent>

        {!isExpanded && (
          <HoverOverlayButton
            $responsiveBreakpointsV2={responsiveBreakpointsV2}
          >
            <Button
              variant="primary"
              setting="player"
              mode="dark"
              onClick={() => setIsExpanded(true)}
              style={{ width: '100%' }}
            >
              {t('release-info.expand-details')}
            </Button>
          </HoverOverlayButton>
        )}
      </PromoContainer>
    </Promo>
  )
}
